import apiClient from './api.ts';
import type {LetterGradeInputSchema, LetterGradeLookupParams} from "@/types/letter_grade_schema.ts";

export default {
    async getAllLetterGrades(isActive: boolean, page: number, pageSize: number) {
        return await apiClient.get(`letter-grades?is_active=${isActive}&page=${page}&offset=${pageSize}`);
    },
    async createLetterGrade(letterGrade: LetterGradeInputSchema) {
        return await apiClient.post(`letter-grades`, letterGrade);
    },
    async getLetterGradeById(letterGradeId: number) {
        return await apiClient.get(`letter-grades/${letterGradeId}`);
    },
    async lookupLetterGrade(params: LetterGradeLookupParams) {
        const query = new URLSearchParams({
            period_id: String(params.period_id),
            class_id: String(params.class_id),
        });

        if (params.score_group_id) {
            // Per-group scope. type optional; BE defaults to 'course'. course_id mutex.
            query.set('score_group_id', String(params.score_group_id));
        } else {
            query.set('type', params.type);
            if (params.type === 'course' && params.course_id) {
                query.set('course_id', String(params.course_id));
            }
        }

        return await apiClient.get(`letter-grades/lookup?${query}`);
    },
    async updateLetterGrade(letterGradeId: number, letterGrade: LetterGradeInputSchema) {
        return await apiClient.put(`letter-grades/${letterGradeId}`, letterGrade);
    },
    async deleteLetterGrade(letterGradeId: number) {
        return await apiClient.delete(`letter-grades/${letterGradeId}`);
    },
    async archiveLetterGrade(letterGradeId: number) {
        return await apiClient.put(`letter-grades/${letterGradeId}/archive`);
    },
    async unarchiveLetterGrade(letterGradeId: number) {
        return await apiClient.put(`letter-grades/${letterGradeId}/unarchive`);
    }
};
